<p-menubar [model]="mainMenuItems"
           breakpoint="700px">
  <ng-template #start>
    <img class="navbar-brand"
         [src]="logoUrl"
         [routerLink]="'/'"
         alt="Flyht" />
  </ng-template>
  <ng-template #end>
    <div class="flex items-center gap-2">
      <a *ngIf="(enableUserManagement$ | async)?.value"
         class="link-item"
         routerLink="/user-management"
         routerLinkActive="active">
        User management
      </a>
      <p-menu #menu
              [model]="userMenuItems"
              aria-label="user-menu"
              [popup]="true">
        <ng-template #start>
          <button pRipple
                  class="w-full p-2">
            <span class="inline-flex flex-col">
              <span class="font-bold">{{auth.user.email}}</span>
              <span class="text-sm">{{auth.user.company}}</span>
            </span>
          </button>
        </ng-template>
      </p-menu>
      <button pButton
              pRipple
              type=" button"
              icon="fa fa-user"
              aria-label="user-icon"
              size="large"
              class="p-button-rounded p-button-text "
              (click)="menu.toggle($event)">
      </button>
    </div>
  </ng-template>
</p-menubar>

<p-menubar *ngIf="hasSubHeader"
           [model]="secondaryNav.menuItems"
           class="secondary-nav"
           aria-label="secondary-nav"
           breakpoint="400px">
</p-menubar>